import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const PackageCardWrapperStyles = ({
  theme,
  height,
  labelType,
  extraTopSpacingForLabel,
  mobileCarousel,
  layout,
}) => {
  const PackageCard = theme?.components?.PackageCard
  const labelInside =
    labelType === 'contentfulLabel' &&
    PackageCard?.label?.inside &&
    layout !== 'Horizontal'

  return css`
    isolation: isolate; // needed for the label to be on top of the card. Reduces the risk of the label being covered by other elements
    position: relative;

    @media (max-width: 940px) {
      ${extraTopSpacingForLabel &&
      `
        padding-top: ${!labelInside && !mobileCarousel ? height : '0'}px;};
      `}
    }
  `
}

export const PackageCardWrapper = styled.div(PackageCardWrapperStyles)

export const CustomText = styled.h4(
  ({ theme }) => css`
    font-family: ${theme?.fonts?.body?.family};
    font-weight: ${theme?.components?.Price?.dollar?.weight || 'bold'};
    font-size: ${theme?.components?.Price?.dollarSign?.size
      ? theme?.components?.Price?.dollarSign?.size
      : '1em'};
    line-height: 1;
    margin-bottom: 0;
  `
)

export const CustomTextContainer = styled.span(({ theme, inPackageCard }) => {
  let color = 'inherit'

  if (theme?.components?.Price?.color) {
    color = theme?.components?.Price?.color
  } else if (inPackageCard) {
    color = theme?.components?.PackageCard?.color || 'black'
  }

  return css`
    margin: 0 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${CustomText}, .leshen-brandy {
      color: ${color} !important;
    }

    .leshen-brandy:last-child {
      margin-bottom: 0;
    }
  `
})
